<template>
  
  <div class="about">
    <!-- Image Background Section -->
    <section class="relative w-full h-[60vh] md:h-[70vh] lg:h-[80vh] overflow-hidden" style="margin-top: 80px;">
      <img 
        src="/assets/images/image-qs.png" 
        alt="Quem Somos" 
        class="absolute top-0 left-0 w-full h-full object-cover"
      >
      
      <!-- Rabisto GIF Overlay -->
      <div class="absolute inset-0 flex items-center justify-center z-10">
        <img 
          src="/assets/images/rabisco.gif" 
          alt="Rabisto Animation" 
          class="max-w-full max-h-full object-contain"
        >
      </div>
      
      <!-- Overlay -->
      <div class="absolute inset-0 bg-black bg-opacity-30 z-5"></div>
    </section>

    <!-- Main Content Section -->
    <section class="bg-white py-20 md:py-30 lg:py-40 px-6">
      <div class="max-w-6xl mx-auto">
        <div class="text-center max-w-4xl mx-auto">
          <h1 class="text-3xl sm:text-4xl md:text-4xl lg:text-5xl xl:text-5xl font-light mb-8 md:mb-16 leading-tight">
            {{ aboutTitle }}
          </h1>
          <div class="space-y-4 text-lg md:text-xl text-black">
            <p class="font-medium">{{ aboutSubtitle }}</p>
            <p v-for="(paragraph, index) in aboutDescription" :key="index" class="leading-relaxed" v-html="paragraph">
            </p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import pt from '@/i18n/locales/pt.js'
import enUS from '@/i18n/locales/en-US.js'

export default {
  name: 'About',
  setup() {
    const { locale } = useI18n()
    
    const aboutTitle = computed(() => {
      const messages = locale.value === 'pt' ? pt : enUS
      return messages.about.title
    })
    
    const aboutSubtitle = computed(() => {
      const messages = locale.value === 'pt' ? pt : enUS
      return messages.about.subtitle
    })
    
    const aboutDescription = computed(() => {
      const messages = locale.value === 'pt' ? pt : enUS
      return messages.about.description
    })
    
    return {
      aboutTitle,
      aboutSubtitle,
      aboutDescription
    }
  }
}
</script>

<style scoped>
/* Estilos específicos da página About */
</style> 